import type { DossierVue } from './types.js';

export type EtatEcran =
  { type: 'sans-dossier' } | { type: 'chargement' } | { type: 'pret'; dossier: DossierVue } | { type: 'erreur'; message: string };

export type ActionEcran = { type: 'charger' } | { type: 'charge'; dossier: DossierVue } | { type: 'echec'; message: string };

export const ETAT_ECRAN_INITIAL: EtatEcran = { type: 'sans-dossier' };

export const etatInitial = (idDossier: string | null): EtatEcran => (idDossier === null ? ETAT_ECRAN_INITIAL : { type: 'chargement' });

export function reducerEcran(_etat: EtatEcran, action: ActionEcran): EtatEcran {
  switch (action.type) {
    case 'charger':
      return { type: 'chargement' };
    case 'charge':
      return { type: 'pret', dossier: action.dossier };
    case 'echec':
      return { type: 'erreur', message: action.message };
  }
}

/** Le dossier ouvert est désigné par `?dossier=` dans l’adresse. */
export function idDossierDepuisAdresse(recherche: string): string | null {
  const id = new URLSearchParams(recherche).get('dossier')?.trim();
  return id ? id : null;
}
